/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { DaypartResult } from '../models/daypart-result';
import { daypartsDaypartIdDelete } from '../fn/dayparts/dayparts-daypart-id-delete';
import { DaypartsDaypartIdDelete$Params } from '../fn/dayparts/dayparts-daypart-id-delete';
import { daypartsDaypartIdGet } from '../fn/dayparts/dayparts-daypart-id-get';
import { DaypartsDaypartIdGet$Params } from '../fn/dayparts/dayparts-daypart-id-get';
import { daypartsDaypartIdMenusMenuIdDelete } from '../fn/dayparts/dayparts-daypart-id-menus-menu-id-delete';
import { DaypartsDaypartIdMenusMenuIdDelete$Params } from '../fn/dayparts/dayparts-daypart-id-menus-menu-id-delete';
import { daypartsDaypartIdMenusMenuIdGet } from '../fn/dayparts/dayparts-daypart-id-menus-menu-id-get';
import { DaypartsDaypartIdMenusMenuIdGet$Params } from '../fn/dayparts/dayparts-daypart-id-menus-menu-id-get';
import { daypartsDaypartIdMenusMenuIdItemsItemIdDelete } from '../fn/dayparts/dayparts-daypart-id-menus-menu-id-items-item-id-delete';
import { DaypartsDaypartIdMenusMenuIdItemsItemIdDelete$Params } from '../fn/dayparts/dayparts-daypart-id-menus-menu-id-items-item-id-delete';
import { daypartsDaypartIdMenusMenuIdItemsItemIdGet } from '../fn/dayparts/dayparts-daypart-id-menus-menu-id-items-item-id-get';
import { DaypartsDaypartIdMenusMenuIdItemsItemIdGet$Params } from '../fn/dayparts/dayparts-daypart-id-menus-menu-id-items-item-id-get';
import { daypartsDaypartIdMenusMenuIdItemsItemIdPut } from '../fn/dayparts/dayparts-daypart-id-menus-menu-id-items-item-id-put';
import { DaypartsDaypartIdMenusMenuIdItemsItemIdPut$Params } from '../fn/dayparts/dayparts-daypart-id-menus-menu-id-items-item-id-put';
import { daypartsDaypartIdMenusMenuIdPut } from '../fn/dayparts/dayparts-daypart-id-menus-menu-id-put';
import { DaypartsDaypartIdMenusMenuIdPut$Params } from '../fn/dayparts/dayparts-daypart-id-menus-menu-id-put';
import { daypartsDaypartIdPut } from '../fn/dayparts/dayparts-daypart-id-put';
import { DaypartsDaypartIdPut$Params } from '../fn/dayparts/dayparts-daypart-id-put';
import { daypartsDaypartIdStoresStoreIdDelete } from '../fn/dayparts/dayparts-daypart-id-stores-store-id-delete';
import { DaypartsDaypartIdStoresStoreIdDelete$Params } from '../fn/dayparts/dayparts-daypart-id-stores-store-id-delete';
import { daypartsDaypartIdStoresStoreIdGet } from '../fn/dayparts/dayparts-daypart-id-stores-store-id-get';
import { DaypartsDaypartIdStoresStoreIdGet$Params } from '../fn/dayparts/dayparts-daypart-id-stores-store-id-get';
import { daypartsDaypartIdStoresStoreIdPut } from '../fn/dayparts/dayparts-daypart-id-stores-store-id-put';
import { DaypartsDaypartIdStoresStoreIdPut$Params } from '../fn/dayparts/dayparts-daypart-id-stores-store-id-put';
import { daypartsGet } from '../fn/dayparts/dayparts-get';
import { DaypartsGet$Params } from '../fn/dayparts/dayparts-get';
import { daypartsPost } from '../fn/dayparts/dayparts-post';
import { DaypartsPost$Params } from '../fn/dayparts/dayparts-post';
import { HalJson } from '../models/hal-json';
import { ItemMenuDaypartResult } from '../models/item-menu-daypart-result';
import { MenuDaypartResult } from '../models/menu-daypart-result';
import { menusMenuIdDaypartsGet } from '../fn/dayparts/menus-menu-id-dayparts-get';
import { MenusMenuIdDaypartsGet$Params } from '../fn/dayparts/menus-menu-id-dayparts-get';
import { StoreDaypartResult } from '../models/store-daypart-result';
import { storesStoreIdDaypartsGet } from '../fn/dayparts/stores-store-id-dayparts-get';
import { StoresStoreIdDaypartsGet$Params } from '../fn/dayparts/stores-store-id-dayparts-get';

@Injectable({ providedIn: 'root' })
export class DaypartsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `daypartsGet()` */
  static readonly DaypartsGetPath = '/dayparts';

  /**
   * Get dayparts for a tenant.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `daypartsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  daypartsGet$Response(params: DaypartsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'_links'?: HalJson;
'_embedded'?: {
'dayparts'?: Array<DaypartResult>;
};
}>> {
    return daypartsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get dayparts for a tenant.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `daypartsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  daypartsGet(params: DaypartsGet$Params, context?: HttpContext): Observable<{
'_links'?: HalJson;
'_embedded'?: {
'dayparts'?: Array<DaypartResult>;
};
}> {
    return this.daypartsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'_links'?: HalJson;
'_embedded'?: {
'dayparts'?: Array<DaypartResult>;
};
}>): {
'_links'?: HalJson;
'_embedded'?: {
'dayparts'?: Array<DaypartResult>;
};
} => r.body)
    );
  }

  /** Path part for operation `daypartsPost()` */
  static readonly DaypartsPostPath = '/dayparts';

  /**
   * Create Dayparts for a tenant.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `daypartsPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  daypartsPost$Response(params: DaypartsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'_links'?: HalJson;
'daypartId'?: string;
}>> {
    return daypartsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create Dayparts for a tenant.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `daypartsPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  daypartsPost(params: DaypartsPost$Params, context?: HttpContext): Observable<{
'_links'?: HalJson;
'daypartId'?: string;
}> {
    return this.daypartsPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'_links'?: HalJson;
'daypartId'?: string;
}>): {
'_links'?: HalJson;
'daypartId'?: string;
} => r.body)
    );
  }

  /** Path part for operation `daypartsDaypartIdGet()` */
  static readonly DaypartsDaypartIdGetPath = '/dayparts/{daypartId}';

  /**
   * Get dayparts by ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `daypartsDaypartIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  daypartsDaypartIdGet$Response(params: DaypartsDaypartIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'_links'?: HalJson;
} & DaypartResult>> {
    return daypartsDaypartIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get dayparts by ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `daypartsDaypartIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  daypartsDaypartIdGet(params: DaypartsDaypartIdGet$Params, context?: HttpContext): Observable<{
'_links'?: HalJson;
} & DaypartResult> {
    return this.daypartsDaypartIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'_links'?: HalJson;
} & DaypartResult>): {
'_links'?: HalJson;
} & DaypartResult => r.body)
    );
  }

  /** Path part for operation `daypartsDaypartIdPut()` */
  static readonly DaypartsDaypartIdPutPath = '/dayparts/{daypartId}';

  /**
   * Update Dayparts by ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `daypartsDaypartIdPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  daypartsDaypartIdPut$Response(params: DaypartsDaypartIdPut$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return daypartsDaypartIdPut(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Dayparts by ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `daypartsDaypartIdPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  daypartsDaypartIdPut(params: DaypartsDaypartIdPut$Params, context?: HttpContext): Observable<void> {
    return this.daypartsDaypartIdPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `daypartsDaypartIdDelete()` */
  static readonly DaypartsDaypartIdDeletePath = '/dayparts/{daypartId}';

  /**
   * Remove dayparts by ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `daypartsDaypartIdDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  daypartsDaypartIdDelete$Response(params: DaypartsDaypartIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return daypartsDaypartIdDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Remove dayparts by ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `daypartsDaypartIdDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  daypartsDaypartIdDelete(params: DaypartsDaypartIdDelete$Params, context?: HttpContext): Observable<void> {
    return this.daypartsDaypartIdDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `daypartsDaypartIdStoresStoreIdGet()` */
  static readonly DaypartsDaypartIdStoresStoreIdGetPath = '/dayparts/{daypartId}/stores/{storeId}';

  /**
   * Get dayparts for a store by their respective IDs.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `daypartsDaypartIdStoresStoreIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  daypartsDaypartIdStoresStoreIdGet$Response(params: DaypartsDaypartIdStoresStoreIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'_links'?: HalJson;
} & StoreDaypartResult>> {
    return daypartsDaypartIdStoresStoreIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get dayparts for a store by their respective IDs.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `daypartsDaypartIdStoresStoreIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  daypartsDaypartIdStoresStoreIdGet(params: DaypartsDaypartIdStoresStoreIdGet$Params, context?: HttpContext): Observable<{
'_links'?: HalJson;
} & StoreDaypartResult> {
    return this.daypartsDaypartIdStoresStoreIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'_links'?: HalJson;
} & StoreDaypartResult>): {
'_links'?: HalJson;
} & StoreDaypartResult => r.body)
    );
  }

  /** Path part for operation `daypartsDaypartIdStoresStoreIdPut()` */
  static readonly DaypartsDaypartIdStoresStoreIdPutPath = '/dayparts/{daypartId}/stores/{storeId}';

  /**
   * Link a daypart to a store and set hours.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `daypartsDaypartIdStoresStoreIdPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  daypartsDaypartIdStoresStoreIdPut$Response(params: DaypartsDaypartIdStoresStoreIdPut$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return daypartsDaypartIdStoresStoreIdPut(this.http, this.rootUrl, params, context);
  }

  /**
   * Link a daypart to a store and set hours.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `daypartsDaypartIdStoresStoreIdPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  daypartsDaypartIdStoresStoreIdPut(params: DaypartsDaypartIdStoresStoreIdPut$Params, context?: HttpContext): Observable<void> {
    return this.daypartsDaypartIdStoresStoreIdPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `daypartsDaypartIdStoresStoreIdDelete()` */
  static readonly DaypartsDaypartIdStoresStoreIdDeletePath = '/dayparts/{daypartId}/stores/{storeId}';

  /**
   * Remove dayparts for a store by their respective IDs.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `daypartsDaypartIdStoresStoreIdDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  daypartsDaypartIdStoresStoreIdDelete$Response(params: DaypartsDaypartIdStoresStoreIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return daypartsDaypartIdStoresStoreIdDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Remove dayparts for a store by their respective IDs.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `daypartsDaypartIdStoresStoreIdDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  daypartsDaypartIdStoresStoreIdDelete(params: DaypartsDaypartIdStoresStoreIdDelete$Params, context?: HttpContext): Observable<void> {
    return this.daypartsDaypartIdStoresStoreIdDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `daypartsDaypartIdMenusMenuIdGet()` */
  static readonly DaypartsDaypartIdMenusMenuIdGetPath = '/dayparts/{daypartId}/menus/{menuId}';

  /**
   * Get dayparts for a menu by their respective IDs.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `daypartsDaypartIdMenusMenuIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  daypartsDaypartIdMenusMenuIdGet$Response(params: DaypartsDaypartIdMenusMenuIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'_links'?: HalJson;
} & MenuDaypartResult>> {
    return daypartsDaypartIdMenusMenuIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get dayparts for a menu by their respective IDs.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `daypartsDaypartIdMenusMenuIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  daypartsDaypartIdMenusMenuIdGet(params: DaypartsDaypartIdMenusMenuIdGet$Params, context?: HttpContext): Observable<{
'_links'?: HalJson;
} & MenuDaypartResult> {
    return this.daypartsDaypartIdMenusMenuIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'_links'?: HalJson;
} & MenuDaypartResult>): {
'_links'?: HalJson;
} & MenuDaypartResult => r.body)
    );
  }

  /** Path part for operation `daypartsDaypartIdMenusMenuIdPut()` */
  static readonly DaypartsDaypartIdMenusMenuIdPutPath = '/dayparts/{daypartId}/menus/{menuId}';

  /**
   * Link a daypart to a menu and set hours.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `daypartsDaypartIdMenusMenuIdPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  daypartsDaypartIdMenusMenuIdPut$Response(params: DaypartsDaypartIdMenusMenuIdPut$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return daypartsDaypartIdMenusMenuIdPut(this.http, this.rootUrl, params, context);
  }

  /**
   * Link a daypart to a menu and set hours.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `daypartsDaypartIdMenusMenuIdPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  daypartsDaypartIdMenusMenuIdPut(params: DaypartsDaypartIdMenusMenuIdPut$Params, context?: HttpContext): Observable<void> {
    return this.daypartsDaypartIdMenusMenuIdPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `daypartsDaypartIdMenusMenuIdDelete()` */
  static readonly DaypartsDaypartIdMenusMenuIdDeletePath = '/dayparts/{daypartId}/menus/{menuId}';

  /**
   * Remove dayparts for a menu by their respective IDs.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `daypartsDaypartIdMenusMenuIdDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  daypartsDaypartIdMenusMenuIdDelete$Response(params: DaypartsDaypartIdMenusMenuIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return daypartsDaypartIdMenusMenuIdDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Remove dayparts for a menu by their respective IDs.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `daypartsDaypartIdMenusMenuIdDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  daypartsDaypartIdMenusMenuIdDelete(params: DaypartsDaypartIdMenusMenuIdDelete$Params, context?: HttpContext): Observable<void> {
    return this.daypartsDaypartIdMenusMenuIdDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `menusMenuIdDaypartsGet()` */
  static readonly MenusMenuIdDaypartsGetPath = '/menus/{menuId}/dayparts';

  /**
   * Get dayparts for a menu by their respective IDs.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `menusMenuIdDaypartsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  menusMenuIdDaypartsGet$Response(params: MenusMenuIdDaypartsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'_links'?: HalJson;
'_embedded'?: {
'dayparts'?: Array<MenuDaypartResult>;
};
}>> {
    return menusMenuIdDaypartsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get dayparts for a menu by their respective IDs.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `menusMenuIdDaypartsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  menusMenuIdDaypartsGet(params: MenusMenuIdDaypartsGet$Params, context?: HttpContext): Observable<{
'_links'?: HalJson;
'_embedded'?: {
'dayparts'?: Array<MenuDaypartResult>;
};
}> {
    return this.menusMenuIdDaypartsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'_links'?: HalJson;
'_embedded'?: {
'dayparts'?: Array<MenuDaypartResult>;
};
}>): {
'_links'?: HalJson;
'_embedded'?: {
'dayparts'?: Array<MenuDaypartResult>;
};
} => r.body)
    );
  }

  /** Path part for operation `storesStoreIdDaypartsGet()` */
  static readonly StoresStoreIdDaypartsGetPath = '/stores/{storeId}/dayparts';

  /**
   * Get dayparts by store ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `storesStoreIdDaypartsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  storesStoreIdDaypartsGet$Response(params: StoresStoreIdDaypartsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'_links'?: HalJson;
'_embedded'?: {
'dayparts'?: Array<StoreDaypartResult>;
};
}>> {
    return storesStoreIdDaypartsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get dayparts by store ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `storesStoreIdDaypartsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  storesStoreIdDaypartsGet(params: StoresStoreIdDaypartsGet$Params, context?: HttpContext): Observable<{
'_links'?: HalJson;
'_embedded'?: {
'dayparts'?: Array<StoreDaypartResult>;
};
}> {
    return this.storesStoreIdDaypartsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'_links'?: HalJson;
'_embedded'?: {
'dayparts'?: Array<StoreDaypartResult>;
};
}>): {
'_links'?: HalJson;
'_embedded'?: {
'dayparts'?: Array<StoreDaypartResult>;
};
} => r.body)
    );
  }

  /** Path part for operation `daypartsDaypartIdMenusMenuIdItemsItemIdGet()` */
  static readonly DaypartsDaypartIdMenusMenuIdItemsItemIdGetPath = '/dayparts/{daypartId}/menus/{menuId}/items/{itemId}';

  /**
   * Get an item association.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `daypartsDaypartIdMenusMenuIdItemsItemIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  daypartsDaypartIdMenusMenuIdItemsItemIdGet$Response(params: DaypartsDaypartIdMenusMenuIdItemsItemIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'_links'?: HalJson;
} & ItemMenuDaypartResult>> {
    return daypartsDaypartIdMenusMenuIdItemsItemIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get an item association.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `daypartsDaypartIdMenusMenuIdItemsItemIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  daypartsDaypartIdMenusMenuIdItemsItemIdGet(params: DaypartsDaypartIdMenusMenuIdItemsItemIdGet$Params, context?: HttpContext): Observable<{
'_links'?: HalJson;
} & ItemMenuDaypartResult> {
    return this.daypartsDaypartIdMenusMenuIdItemsItemIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'_links'?: HalJson;
} & ItemMenuDaypartResult>): {
'_links'?: HalJson;
} & ItemMenuDaypartResult => r.body)
    );
  }

  /** Path part for operation `daypartsDaypartIdMenusMenuIdItemsItemIdPut()` */
  static readonly DaypartsDaypartIdMenusMenuIdItemsItemIdPutPath = '/dayparts/{daypartId}/menus/{menuId}/items/{itemId}';

  /**
   * Link a daypart to a menu-item combination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `daypartsDaypartIdMenusMenuIdItemsItemIdPut()` instead.
   *
   * This method doesn't expect any request body.
   */
  daypartsDaypartIdMenusMenuIdItemsItemIdPut$Response(params: DaypartsDaypartIdMenusMenuIdItemsItemIdPut$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return daypartsDaypartIdMenusMenuIdItemsItemIdPut(this.http, this.rootUrl, params, context);
  }

  /**
   * Link a daypart to a menu-item combination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `daypartsDaypartIdMenusMenuIdItemsItemIdPut$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  daypartsDaypartIdMenusMenuIdItemsItemIdPut(params: DaypartsDaypartIdMenusMenuIdItemsItemIdPut$Params, context?: HttpContext): Observable<void> {
    return this.daypartsDaypartIdMenusMenuIdItemsItemIdPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `daypartsDaypartIdMenusMenuIdItemsItemIdDelete()` */
  static readonly DaypartsDaypartIdMenusMenuIdItemsItemIdDeletePath = '/dayparts/{daypartId}/menus/{menuId}/items/{itemId}';

  /**
   * Unlink a daypart from the associated menu-item combination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `daypartsDaypartIdMenusMenuIdItemsItemIdDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  daypartsDaypartIdMenusMenuIdItemsItemIdDelete$Response(params: DaypartsDaypartIdMenusMenuIdItemsItemIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return daypartsDaypartIdMenusMenuIdItemsItemIdDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Unlink a daypart from the associated menu-item combination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `daypartsDaypartIdMenusMenuIdItemsItemIdDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  daypartsDaypartIdMenusMenuIdItemsItemIdDelete(params: DaypartsDaypartIdMenusMenuIdItemsItemIdDelete$Params, context?: HttpContext): Observable<void> {
    return this.daypartsDaypartIdMenusMenuIdItemsItemIdDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
